import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { AddressInputFields, FamilyContactInputFields } from 'components/PatientData'
import { AddressAndFamilyContactFormMethods } from '../../useAddressAndFamilyContactForm'

import * as S from './styles'

interface AddressAndFamilyContactFormProps extends AddressAndFamilyContactFormMethods {
  handleFormFulfilled: () => void
}

export const AddressAndFamilyContactForm = ({ 
  handleFormFulfilled,
  ...methods
}: AddressAndFamilyContactFormProps): JSX.Element => {
  
  return (
    <S.Form onSubmit={methods.handleSubmit(handleFormFulfilled)}>
      <S.BlockWrapper>
        <div>
          <Typography variant='content1' weight='bold'>
            Seu endereço
          </Typography>
          <Typography variant='content3' customClassName='subtitle'>
            Para o envio de receitas médicas de Psiquiatria.
          </Typography>
        </div>
        <AddressInputFields {...methods}/>
      </S.BlockWrapper>

      <S.BlockContactWrapper>
        <div>
          <Typography variant='content1' weight='bold'>
            Contato de um familiar
          </Typography>
          <Typography variant='content3' customClassName='subtitle'>
            Para ajudar os profissionais de saúde em casos de emergência. Pode ser seu pai, mãe, irmã(o) ou cônjuge.
          </Typography>
        </div>
        <FamilyContactInputFields {...methods} />
      </S.BlockContactWrapper>

      <Typography variant='content2' italic>
        * Preenchimento obrigatório.
      </Typography>

      <button type='submit'>
        Salvar informações
      </button>
    </S.Form>
  )
}